/**
 * Burger off-canvas meni za ulogovane korisnike i linkove sekcija početne stranice.
 */
import React from 'react';
import { Link } from 'react-router-dom';

import { isAdminRoleName } from '@/shared/auth/obligationAuth';

const MobileNav = ({
  id,
  activeRole,
  displayName,
  profileIcon,
  showUserItems = false,
  showHomeSectionLinks = false,
  homeSectionBurgerSlot = null,
  onCloseBurger,
  onLogout,
}) => (
  <div id={id} className="burger-menu-panel" role="navigation" aria-label="Мобилни мени">
    {showHomeSectionLinks && typeof homeSectionBurgerSlot === 'function'
      ? homeSectionBurgerSlot(onCloseBurger)
      : null}
    {showUserItems && showHomeSectionLinks && (
      <div className="burger-menu-divider" role="separator" aria-hidden="true" />
    )}
    {showUserItems && isAdminRoleName(activeRole) && (
      <Link to="/admin" className="burger-menu-item burger-menu-item--link" onClick={onCloseBurger}>
        Админ панел
      </Link>
    )}
    {showUserItems && (
      <>
        <Link
          to="/profil"
          className="burger-menu-item burger-menu-item--link burger-menu-item--profile"
          onClick={onCloseBurger}
          aria-label={`Мој профил - ${displayName}`}
        >
          <span aria-hidden="true" className="burger-menu-profile-icon">{profileIcon}</span>
          <span>{displayName}</span>
        </Link>
        <button type="button" onClick={onLogout} className="burger-menu-item burger-menu-item--logout">
          <svg aria-hidden="true" className="burger-menu-item-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Одјави се
        </button>
      </>
    )}
  </div>
);

export default MobileNav;
